import { Room } from "../../../../models";
import { RoomByOwnerDTO } from "../dtos/read-room.api.dto";

export const mapRoomsByOwnerId = (room: RoomByOwnerDTO): Pick<Room, "_id" | "name"> => {
  return {
    _id: room._id,
    name: room.name,
  };
};
